module.exports = __webpack_public_path__ + "static/media/rank-09-expert.3e1e1f4b.svg";